import React, {useContext, useEffect, useState} from 'react';
import {NoteBookReportContext} from "./NoteBookReportContext"
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import numericFunction from "../../../utils/NumericFunction";
import {CalenderIcon} from "../../../Assets/svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numeric from "../../../utils/NumericFunction";

function FilterSection(props) {
  // کلید های فیلتر
  const keys = {
    all: "all", yearMonth: "yearMonth", dateBetween: "date", documentNumber: "documentNumber",
  }

  const helper = useContext(NoteBookReportContext);
  const setData = helper.setData
  const data = helper.data


  const testTopFil = {
    type: "", // all yearMonth date,documentId
    year: "", month: "", firstId: "", lastId: "",
  }
  const topFilter = data.filter;


  const [loader, setLoader] = useState(false)


  const [isOpenFilter, setIsOpenFilter] = useState(true)

  const [optionData, setOptionData] = useState({
    yearMonthList: [], monthList: [], documentIdList: [],
  })
  const getFilterData = async () => {
    try {
      const resYearMonthList = await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedYearAndMonth')

      const documentIdList = (await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedDocumentId'))


      setOptionData({
        yearMonthList: resYearMonthList.data.data, documentIdList: documentIdList.data.data
      }) // yearMonthList
      setLoader(false)
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    void getFilterData()
  }, []);


  const requestNewMainData = async () =>  {
    // ارسال درخواست
    try {
      const res = await _axios.get(prefixUrl() + '/accountingBalanceSheet/?request=balanceSheetData_2' + '&dateFilter=' + JSON.stringify(topFilter) + '&filter=' + JSON.stringify(data.filter) + '&reportType=' + data.reportType)

      if (res?.data?.status) {
        setData({...data, mainData: res.data.data})
      } else {
        toast.info(res?.data?.message)
      }
    } catch (error) {
      console.log(error)
    }
  }
  /*
  useEffect(() => {
    void requestNewMainData();
  }, [topFilter.startDate, topFilter.endDate, topFilter.type, topFilter.year, topFilter.month, data.reportType, data.filter?.firstId, data.filter?.lastId,]);
*/

  const yearChangeHandler = (e) => {

    const value = e.target.value;
    const myOptionData = {...optionData}
    const monthList = myOptionData.yearMonthList.find(v => +v.year === +value)?.month


    setData({filter: {...data.filter, year: value, month: ""}})
    setOptionData({...optionData, monthList})
  }

  const monthChangeHandler = (e) => {
    const value = e.target.value;
    setData({...data, filter: {...data.filter, month: value}})

  }
  const typeHandler = (reportType) => {
    setData({...data, reportType})
  }
  return (<div className={"filter__section"}>
     <div className={`my-2  `}
         style={{
           transition: "all 0.3s", height: isOpenFilter ? 80 : 20, borderRadius: 10, // padding: isOpenFilter ? 20 : 0,
           // overflowY: "scroll",
         }}
    >


      <div className={'mb-3'}
           onClick={() => setIsOpenFilter(!isOpenFilter)}
      >
        {!isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <path
    d="M9.99959 14.0001C9.41626 14.0001 8.83293 13.7751 8.39126 13.3334L2.95795 7.90009C2.71629 7.65843 2.71629 7.25843 2.95795 7.01676C3.19962 6.77509 3.59962 6.77509 3.84129 7.01676L9.2746 12.4501C9.6746 12.8501 10.3246 12.8501 10.7246 12.4501L16.1579 7.01676C16.3996 6.77509 16.7996 6.77509 17.0413 7.01676C17.2829 7.25843 17.2829 7.65843 17.0413 7.90009L11.6079 13.3334C11.1663 13.7751 10.5829 14.0001 9.99959 14.0001Z"
    fill="#5D70B5"
  />
</svg>

          </span>}
        {isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <g id="arrow-down-1 10">
    <path
      id="Vector"
      d="M9.99959 5.99994C9.41626 5.99994 8.83293 6.22494 8.39126 6.66661L2.95795 12.0999C2.71629 12.3416 2.71629 12.7416 2.95795 12.9832C3.19962 13.2249 3.59962 13.2249 3.84129 12.9832L9.2746 7.54994C9.6746 7.14994 10.3246 7.14994 10.7246 7.54994L16.1579 12.9832C16.3996 13.2249 16.7996 13.2249 17.0413 12.9832C17.2829 12.7416 17.2829 12.3416 17.0413 12.0999L11.6079 6.66661C11.1663 6.22494 10.5829 5.99994 9.99959 5.99994Z"
      fill="#5D70B5"
    />
  </g>
</svg>
          </span>}

        فیلترها
      </div>
      {isOpenFilter && <>
        <div className={'d-flex'} style={{gap: 20}}>
          <div className={'review__input '}>
            <label htmlFor="yearFiltersReview11">فیلتر</label>
            <select
              className={'width__142'}
              id="yearFiltersReview11"

              value={topFilter.type}
              onChange={e => {
                const value = e.target.value
                setData({filter: {...data.filter, type: value}})
              }}
            >
              <option value={keys.all}>همه</option>
              <option value={keys.yearMonth}>بر اساس سال و ماه</option>
              <option value={keys.dateBetween}>بر اساس بازه زمانی</option>
              <option value={keys.documentNumber}>بر اساس شماره سند</option>
            </select>
          </div>


          {(topFilter.type === keys.all) && <></>}
          {(topFilter.type === keys.yearMonth) && <>

            <div className={'review__input'}>
              <label htmlFor="yearFiltersReview">سال</label>
              <select
                className={'width__142'}
                id={'yearFiltersReview'}
                onChange={yearChangeHandler}
                value={topFilter.year}
                name="yearFiltersReview">
                <option value="" hidden={true}>انتخاب کنید</option>
                {optionData?.yearMonthList?.map((v, i) => {
                  console.log(v)
                  return <option key={i}
                                 value={v.year}>
                    {numericFunction.e2p(v.year)}</option>
                })}
              </select>
            </div>
            <div className={'review__input'}>
              <label htmlFor="monthFiltersReview">ماه</label>
              <select id="monthFiltersReview"
                      className={'width__142'}
                      onChange={monthChangeHandler}
                      value={topFilter.month}
              >
                <option value="" hidden={true}>انتخاب کنید</option>
                {optionData?.monthList?.map(v => <option key={v + ""} value={v + ""}>{v}</option>)}
              </select>
            </div>
          </>}
          {(topFilter.type === keys.dateBetween) && <>
            <div className={'d-flex'}>

              <div className={"review__input"}>
                <label>تاریخ شروع</label>
                <div
                  className="datePicker__review ltr d-flex"
                >
                  <CalenderIcon/>
                  <DatePicker
                    id={"dateHereForm"}
                    calendar={persian}
                    className="classNameOfDatePicker "
                    placeholder="تاریخ"
                    name={"bame"}
                    locale={persian_fa}
                    // ref={dateCal}
                    calendarPosition="bottom-right"
                    hideOnScroll
                    value={topFilter.startDate}
                    onChange={(DateObject) => {
                      if (DateObject) {
                        const temp = numeric.p2e(DateObject.toLocaleString());
                        setData({filter: {...data.filter, startDate: temp}})
                      } else {
                        setData({filter: {...data.filter, startDate: ""}})
                      }
                    }}
                  />
                </div>
              </div>

              <div className={"review__input"}>
                <label>تاریخ پایان</label>
                <div
                  className="datePicker__review ltr d-flex"
                >
                  <CalenderIcon/>
                  <DatePicker
                    id={"dateHereForm"}
                    calendar={persian}
                    // className="classNameOfDatePicker "
                    placeholder="تاریخ"
                    name={"bame"}
                    locale={persian_fa}
                    // ref={dateCal}
                    calendarPosition="bottom-right"
                    hideOnScroll
                    value={topFilter.endDate}
                    onChange={(DateObject) => {
                      if (DateObject) {
                        const temp = numeric.p2e(DateObject.toLocaleString());
                        setData({filter: {...data.filter, endDate: temp}})
                      } else {
                        setData({filter: {...data.filter, endDate: ""}})
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </>}
          {(topFilter.type === keys.documentNumber) && <div>
            <div className={'d-flex'}>
              <div className={'review__input'}>
                <label>از شماره سند</label>
                <select
                  className={'width__142'}

                  onChange={e => {

                    const value = e.target.value
                    const newData = {
                      ...data, filter: {...data.filter, firstId: value}
                    }
                    setData(newData)
                  }}

                  value={data.filter.firstId}
                >
                  <option value="" hidden={false}>از ابتدا</option>
                  {optionData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                </select>
              </div>
              <div className={'review__input'}>
                <label> تا شماره سند</label>
                <select
                  className={'width__142'}

                  onChange={e => {

                    const value = e.target.value
                    const newData = {
                      ...data, filter: {...data.filter, lastId: value}
                    }
                    setData(newData)
                  }}
                  value={data.filter.lastId}
                >
                  <option value="" hidden={false}>تا انتها</option>
                  {optionData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                </select>
              </div>
            </div>

          </div>}

          {<div className={'review__input '}>
            <label htmlFor="yearFiltersReview11">نمایش</label>
            <select
              className={'width__142'}
              id="yearFiltersReview11"
              value={topFilter.reportType}
              onChange={e => {
                const value = e.target.value
                setData({reportType: value})
              }}
            >
              <option value={"1"}>سند</option>
              <option value={"2"}>کد حساب</option>
            </select>
          </div>}
        </div>
      </>}

    </div>


  </div>);

}

export default FilterSection;
